import { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Toggle } from '../../../cdl-react-components/components'
import { contains } from '../../../cdl-react-components/utilities'

class CheckboxSearch extends Component {
    static defaultProps = {
        value: [],
        items: [],
        group: '',
        onChange: () => {},
        disabled: false
    }

    handleOnChange = (id) => (e) => {
        this.props.onChange(
            contains(this.props.value, id) ?
                this.props.value.filter(x => x !== id) :
                [...this.props.value, id])
    }

    handleSelectAllChange = (e) => {
        this.props.onChange(
            e.target.checked ?
                this.props.items.map(x => x.id.toString()) :
                [])
    }

    render() {
        return (
            <div className="search__checkbox-search">
                <Toggle
                    type="checkbox"
                    onChange={this.handleSelectAllChange}
                    checked={this.props.value.length === this.props.items.length}
                    disabled={this.props.disabled}>
                        Select All
                </Toggle>
                <hr />
                { this.props.items.map((item) =>
                    (<Fragment key={`checkbox-${this.props.group}-${item.id}`}>
                        <Toggle
                            type="checkbox"
                            onChange={this.handleOnChange(item.id.toString())}
                            checked={this.props.value && contains(this.props.value, item.id.toString())}
                            disabled={this.props.disabled}>
                                {item.name}
                        </Toggle><br/>
                    </Fragment>)
                ) }
            </div>
        )
    }
}

CheckboxSearch.propTypes = {
    value: PropTypes.arrayOf(PropTypes.string).isRequired,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    group: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool
}

export default CheckboxSearch